<template>
  <b-modal
    v-model="modalShow"
    ref="modal-cancel"
    size="xl"
    :title="
      'Comissões do Perfil ' +
      profile.name +
      ' para a Administradora ' +
      administrator.name
    "
  >
    <b-form novalidate="novalidate" autocomplete="off">
      <div>
        <b-tabs>
          <b-tab title="Geral" active>
            <div class="row">
              <div class="col-md-3">
                <div
                  class="form-group bmd-form-group"
                  v-bind:class="{ 'is-filled': true }"
                >
                  <label for="comission_default" class="bmd-label-floating"
                    >Comissão de Venda Padrão %</label
                  >
                  <money
                    v-model="form.default.comission"
                    maxlength="9"
                    class="form-control"
                    v-bind="percent"
                    placeholder=""
                  ></money>
                  <label
                    v-if="validation.default.comission != ''"
                    id="default-commission-error"
                    class="error"
                    for="default_commission"
                    >{{ validation.default.comission }}</label
                  >
                </div>
              </div>
            </div>
            <hr />
            <h5>Comissão de Implantação</h5>
            <div class="row">
              <div class="col-md-3">
                <div
                  class="form-group bmd-form-group"
                  v-bind:class="{ 'is-filled': true }"
                >
                  <label for="min_quotes" class="bmd-label-floating"
                    >Min. Cotas</label
                  >
                  <money
                    v-model="form.default.min_quotes"
                    maxlength="3"
                    class="form-control"
                    v-bind="integer"
                    placeholder=""
                  ></money>
                  <label
                    v-if="validation.default.min_quotes != ''"
                    id="min_quotes-error"
                    class="error"
                    for="min_quotes"
                    >{{ validation.default.min_quotes }}</label
                  >
                </div>
              </div>
              <div class="col-md-3">
                <div
                  class="form-group bmd-form-group"
                  v-bind:class="{ 'is-filled': true }"
                >
                  <label for="max_quotes" class="bmd-label-floating"
                    >Max. Cotas</label
                  >
                  <money
                    v-model="form.default.max_quotes"
                    maxlength="3"
                    class="form-control"
                    v-bind="integer"
                    placeholder=""
                  ></money>
                  <label
                    v-if="validation.default.max_quotes != ''"
                    id="max_quotes-error"
                    class="error"
                    for="max_quotes"
                    >{{ validation.default.max_quotes }}</label
                  >
                </div>
              </div>
              <div class="col-md-3">
                <div
                  class="form-group bmd-form-group"
                  v-bind:class="{ 'is-filled': true }"
                >
                  <label for="deployment_commision" class="bmd-label-floating"
                    >Valor da Comissão (fixo)</label
                  >
                  <money
                    v-model="form.default.deployment_commision"
                    maxlength="13"
                    class="form-control"
                    v-bind="money"
                    placeholder=""
                  ></money>
                  <label
                    v-if="validation.default.deployment_commision != ''"
                    id="deployment_commision-error"
                    class="error"
                    for="deployment_commision"
                    >{{ validation.default.deployment_commision }}</label
                  >
                </div>
              </div>
            </div>
            <hr />
            <h5>
              Veículos Comissionados
              <b-button variant="success" @click="addVehicleCommission()"
                >Adicionar</b-button
              >
            </h5>
            <div
              class="row"
              v-show="form.default.commissioned_vehicles.length > 0"
              v-for="iterator in form.default.commissioned_vehicles"
            >
              <div class="col-md-6">
                <div class="form-group bmd-form-group is-filled">
                  <label for="manufacturer_id" class="bmd-label-floating"
                    >Fabricante / Modelo</label
                  >
                  <model-list-select
                    class="form-control"
                    :list="manufacturer_models"
                    option-value="id"
                    option-text="name"
                    v-model="iterator.model_id"
                  >
                  </model-list-select>
                </div>
              </div>
              <div class="col-md-3">
                <div
                  class="form-group bmd-form-group"
                  v-bind:class="{ 'is-filled': true }"
                >
                  <label for="commission" class="bmd-label-floating"
                    >Comissão (%)</label
                  >
                  <money
                    v-model="iterator.comission"
                    maxlength="9"
                    class="form-control"
                    v-bind="percent"
                    placeholder=""
                  ></money>
                </div>
              </div>
              <div class="col-md-3">
                <b-button
                  block
                  variant="danger"
                  @click="removeVehicleCommission(iterator)"
                  >Remover</b-button
                >
              </div>
            </div>
            <hr />
            <h5>
              Inadiplência
              <b-button right variant="success" @click="addInadvertence()"
                >Adicionar</b-button
              >
            </h5>
            <div
              class="row"
              v-show="form.default.inadvertencies.length > 0"
              v-for="iterator in form.default.inadvertencies"
            >
              <div class="col-md-1">
                <div
                  class="form-group bmd-form-group"
                  v-bind:class="{ 'is-filled': true }"
                >
                  <label for="minimum_percentage" class="bmd-label-floating"
                    >% Mínima</label
                  >
                  <money
                    v-model="iterator.minimum_percentage"
                    maxlength="9"
                    class="form-control"
                    v-bind="percent"
                    placeholder=""
                  ></money>
                </div>
              </div>
              <div class="col-md-1">
                <div
                  class="form-group bmd-form-group"
                  v-bind:class="{ 'is-filled': true }"
                >
                  <label for="maximum_percentage" class="bmd-label-floating"
                    >% Máxima</label
                  >
                  <money
                    v-model="iterator.maximum_percentage"
                    maxlength="9"
                    class="form-control"
                    v-bind="percent"
                    placeholder=""
                  ></money>
                </div>
              </div>
              <div class="col-md-1">
                <div
                  class="form-group bmd-form-group"
                  v-bind:class="{ 'is-filled': true }"
                >
                  <label for="value" class="bmd-label-floating"
                    >Valor (R$)</label
                  >
                  <money
                    v-model="iterator.value"
                    maxlength="13"
                    class="form-control"
                    v-bind="money"
                    placeholder=""
                  ></money>
                </div>
              </div>
              <div class="col-md-1">
                <div
                  class="form-group bmd-form-group"
                  v-bind:class="{ 'is-filled': true }"
                >
                  <label for="portion" class="bmd-label-floating"
                    >Parcela</label
                  >
                  <money
                    v-model="iterator.portion"
                    maxlength="3"
                    class="form-control"
                    v-bind="integer"
                    placeholder=""
                  ></money>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group bmd-form-group is-filled">
                  <label for="type" class="bmd-label-floating">Tipo</label>
                  <model-list-select
                    class="form-control"
                    :list="types"
                    option-value="id"
                    option-text="name"
                    v-model="iterator.type"
                  >
                  </model-list-select>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group bmd-form-group is-filled">
                  <label for="type" class="bmd-label-floating">Forma</label>
                  <model-list-select
                    class="form-control"
                    :list="methods"
                    option-value="id"
                    option-text="name"
                    v-model="iterator.method"
                  >
                  </model-list-select>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group bmd-form-group is-filled">
                  <label for="type" class="bmd-label-floating"
                    >Tipo da Parcela</label
                  >
                  <model-list-select
                    class="form-control"
                    :list="type_portions"
                    option-value="id"
                    option-text="name"
                    v-model="iterator.type_portion"
                  >
                  </model-list-select>
                </div>
              </div>
              <div class="col-md-2">
                <b-button
                  block
                  variant="danger"
                  @click="removeInadvertence(iterator)"
                  >Remover</b-button
                >
              </div>
            </div>
            <hr />
            <h5>Contemplação</h5>
            <div class="row">
              <div class="col-md-3">
                <div
                  class="form-group bmd-form-group"
                  v-bind:class="{ 'is-filled': true }"
                >
                  <label
                    for="comission_contemplation"
                    class="bmd-label-floating"
                    >Comissão%</label
                  >
                  <money
                    v-model="form.default.comission_contemplation"
                    maxlength="9"
                    class="form-control"
                    v-bind="percent"
                    placeholder=""
                  ></money>
                </div>
              </div>
            </div>
            <hr />
            <h5>Faturamento</h5>
            <div class="row">
              <div class="col-md-3">
                <div
                  class="form-group bmd-form-group"
                  v-bind:class="{ 'is-filled': true }"
                >
                  <label for="billing_commission" class="bmd-label-floating"
                    >Comissão</label
                  >
                  <money
                    v-if="form.default.billing_commission_type != 'F'"
                    v-model="form.default.billing_commission"
                    maxlength="9"
                    class="form-control"
                    v-bind="percent"
                    placeholder=""
                  ></money>
                  <money
                    v-if="form.default.billing_commission_type == 'F'"
                    v-model="form.default.billing_commission"
                    maxlength="13"
                    class="form-control"
                    v-bind="money"
                    placeholder=""
                  ></money>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group bmd-form-group is-filled">
                  <label for="type" class="bmd-label-floating">Tipo</label>
                  <model-list-select
                    class="form-control"
                    :list="types"
                    option-value="id"
                    option-text="name"
                    v-model="form.default.billing_commission_type"
                  >
                  </model-list-select>
                </div>
              </div>
            </div>
            <hr />
            <h5>
              Grupos Comissionados
              <b-button variant="success" @click="addGroupCommission()"
                >Adicionar</b-button
              >
            </h5>
            <div
              class="row"
              v-show="form.default.groups.length > 0"
              v-for="iterator in form.default.groups"
            >
              <div class="col-md-3">
                <div class="form-group bmd-form-group is-filled">
                  <label for="type" class="bmd-label-floating">Grupo</label>
                  <model-list-select
                    class="form-control"
                    :list="groups"
                    option-value="id"
                    option-text="name"
                    v-model="iterator.group_id"
                  >
                  </model-list-select>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group bmd-form-group is-filled">
                  <label for="type" class="bmd-label-floating">Tipo</label>
                  <model-list-select
                    class="form-control"
                    :list="types"
                    option-value="id"
                    option-text="name"
                    v-model="iterator.group_commission_type"
                  >
                  </model-list-select>
                </div>
              </div>
              <div class="col-md-3">
                <div
                  class="form-group bmd-form-group"
                  v-bind:class="{ 'is-filled': true }"
                >
                  <label for="group_commission" class="bmd-label-floating"
                    >Comissão</label
                  >
                  <money
                    v-if="iterator.group_commission_type != 'F'"
                    v-model="iterator.comission"
                    maxlength="9"
                    class="form-control"
                    v-bind="percent"
                    placeholder=""
                  ></money>
                  <money
                    v-if="iterator.group_commission_type == 'F'"
                    v-model="iterator.comission"
                    maxlength="13"
                    class="form-control"
                    v-bind="money"
                    placeholder=""
                  ></money>
                </div>
              </div>
              <div class="col-md-3">
                <b-button
                  block
                  variant="danger"
                  @click="removeGroupCommission(iterator)"
                  >Remover</b-button
                >
              </div>
            </div>
          </b-tab>
          <b-tab title="Bônus">
            <hr />
            <h5>Por Percentual</h5>
            <div class="row">
              <div class="col-md-4">
                <div
                  class="form-group bmd-form-group"
                  v-bind:class="{ 'is-filled': true }"
                >
                  <label for="initial_date" class="bmd-label-floating"
                    >Data Inicial</label
                  >
                  <date-picker
                    v-model="form.bonus.initial_date"
                    lang="pt-br"
                    format="DD/MM/YYYY"
                    placeholder="Escolha uma data"
                  ></date-picker>
                </div>
              </div>
              <div class="col-md-4">
                <div
                  class="form-group bmd-form-group"
                  v-bind:class="{ 'is-filled': true }"
                >
                  <label for="final_date" class="bmd-label-floating"
                    >Data Inicial</label
                  >
                  <date-picker
                    v-model="form.bonus.final_date"
                    lang="pt-br"
                    format="DD/MM/YYYY"
                    placeholder="Escolha uma data"
                  ></date-picker>
                </div>
              </div>
              <div class="col-md-4">
                <div
                  class="form-group bmd-form-group"
                  v-bind:class="{ 'is-filled': true }"
                >
                  <label for="qtd_quotas" class="bmd-label-floating"
                    >Quant. de Cotas</label
                  >
                  <money
                    v-model="form.bonus.qtd_quotas"
                    maxlength="7"
                    class="form-control"
                    v-bind="integer"
                    placeholder=""
                  ></money>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <div class="form-group bmd-form-group is-filled">
                  <label for="bonus_1" class="bmd-label-floating"
                    >Valor Bonus 1</label
                  >
                  <money
                    v-model="form.bonus.bonus_1"
                    maxlength="13"
                    class="form-control"
                    v-bind="money"
                    placeholder=""
                  ></money>
                  <small class="text-info"
                    >Será utilizado se a meta form batida</small
                  >
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group bmd-form-group is-filled">
                  <label for="cut_value" class="bmd-label-floating"
                    >Valor de Corte</label
                  >
                  <money
                    v-model="form.bonus.cut_value"
                    maxlength="13"
                    class="form-control"
                    v-bind="money"
                    placeholder=""
                  ></money>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group bmd-form-group is-filled">
                  <label for="bonus_2" class="bmd-label-floating"
                    >Valor Bonus 2</label
                  >
                  <money
                    v-model="form.bonus.bonus_2"
                    maxlength="13"
                    class="form-control"
                    v-bind="money"
                    placeholder=""
                  ></money>
                  <small class="text-info"
                    >Será utilizado caso o valor das vendas seja maior que a
                    meta</small
                  >
                </div>
              </div>
            </div>
            <hr />
            <h5>
              Por Parcela
              <b-button variant="success" @click="addBonusQuota()"
                >Adicionar</b-button
              >
            </h5>
            <div
              class="row"
              v-show="form.bonus.by_quotas.length > 0"
              v-for="iterator in form.bonus.by_quotas"
            >
              <div class="col-md-2">
                <div class="form-group bmd-form-group is-filled">
                  <label for="num_quote" class="bmd-label-floating"
                    >Parcela</label
                  >
                  <money
                    v-model="iterator.num_quote"
                    maxlength="3"
                    class="form-control"
                    v-bind="integer"
                    placeholder=""
                  ></money>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group bmd-form-group is-filled">
                  <label for="vl_bonus" class="bmd-label-floating"
                    >Bonus %</label
                  >
                  <money
                    v-model="iterator.vl_bonus"
                    maxlength="9"
                    class="form-control"
                    v-bind="percent"
                    placeholder=""
                  ></money>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group bmd-form-group is-filled">
                  <label for="vl_cut" class="bmd-label-floating"
                    >Valor de Corte %</label
                  >
                  <money
                    v-model="iterator.vl_cut"
                    maxlength="9"
                    class="form-control"
                    v-bind="percent"
                    placeholder=""
                  ></money>
                  <small class="text-info"
                    >Valor do corte de inadiplência</small
                  >
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group bmd-form-group is-filled">
                  <label for="type" class="bmd-label-floating"
                    >Se a parcela estiver paga</label
                  >
                  <model-list-select
                    class="form-control"
                    :list="quotas"
                    option-value="id"
                    option-text="id"
                    v-model="iterator.ref_quota"
                  >
                  </model-list-select>
                  <small class="text-info"></small>
                </div>
              </div>
              <div class="col-md-4">
                <b-button
                  block
                  variant="danger"
                  @click="remBonusQuota(iterator)"
                  >Remover</b-button
                >
              </div>
            </div>
          </b-tab>
          <b-tab title="Faixas">
            <hr />
            <h5>
              Indicadores de Desempenho(Faturamento)
              <b-button variant="success" @click="addRange()"
                >Adicionar</b-button
              >
            </h5>
            <div
              class="row"
              v-show="form.billing.ranges.length > 0"
              v-for="iterator in form.billing.ranges"
            >
              <div class="col-md-3">
                <div class="form-group bmd-form-group is-filled">
                  <label class="bmd-label-floating">Inicial</label>
                  <money
                    v-model="iterator.initial_billing"
                    maxlength="13"
                    class="form-control"
                    v-bind="money"
                    placeholder=""
                  ></money>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group bmd-form-group is-filled">
                  <label class="bmd-label-floating">Final</label>
                  <money
                    v-model="iterator.final_billing"
                    maxlength="13"
                    class="form-control"
                    v-bind="money"
                    placeholder=""
                  ></money>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group bmd-form-group is-filled">
                  <label class="bmd-label-floating">Valor</label>
                  <money
                    v-model="iterator.commission"
                    maxlength="13"
                    class="form-control"
                    v-bind="money"
                    placeholder=""
                  ></money>
                </div>
              </div>
              <div class="col-md-3">
                <b-button block variant="danger" @click="removeRange(iterator)"
                  >Remover</b-button
                >
              </div>
            </div>
          </b-tab>
          <b-tab title="Prêmio por Volume">
            <hr />
            <h5>Validade da Campanha</h5>
            <div class="row">
              <div class="col-md-3">
                <div
                  class="form-group bmd-form-group"
                  v-bind:class="{ 'is-filled': true }"
                >
                  <label for="initial_campaign" class="bmd-label-floating"
                    >Data Inicial</label
                  >
                  <date-picker
                    v-model="form.campaign.initial_date"
                    lang="pt-br"
                    format="DD/MM/YYYY"
                    placeholder="Escolha uma data"
                  ></date-picker>
                </div>
              </div>
              <div class="col-md-3">
                <div
                  class="form-group bmd-form-group"
                  v-bind:class="{ 'is-filled': true }"
                >
                  <label for="final_campaign" class="bmd-label-floating"
                    >Data Final</label
                  >
                  <date-picker
                    v-model="form.campaign.final_date"
                    lang="pt-br"
                    format="DD/MM/YYYY"
                    placeholder="Escolha uma data"
                  ></date-picker>
                </div>
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-md-3">
                <div
                  class="form-group bmd-form-group"
                  v-bind:class="{ 'is-filled': true }"
                >
                  <label
                    for="form.campaign.min_quantity"
                    class="bmd-label-floating"
                    >Mínimo de Cotas</label
                  >
                  <input
                    type="number"
                    v-model="form.campaign.min_quantity"
                    maxlength="3"
                    class="form-control"
                    placeholder=""
                  />
                </div>
              </div>
              <div class="col-md-3">
                <div
                  class="form-group bmd-form-group"
                  v-bind:class="{ 'is-filled': true }"
                >
                  <label
                    for="form.campaign.commission"
                    class="bmd-label-floating"
                    >Valor da comissão</label
                  >
                  <money
                    v-model="form.campaign.commission"
                    maxlength="13"
                    class="form-control"
                    v-bind="money"
                    placeholder=""
                  ></money>
                </div>
              </div>
            </div>
            <hr />
            <h5>
              Volume de Cotas
              <b-button variant="success" @click="addQuota()"
                >Adicionar</b-button
              >
            </h5>
            <div
              class="row"
              v-show="form.campaign.quotas.length > 0"
              v-for="iterator in form.campaign.quotas"
            >
              <div class="col-md-2">
                <div class="form-group bmd-form-group is-filled">
                  <label class="bmd-label-floating">Cota Mín</label>
                  <money
                    v-model="iterator.min_quota"
                    maxlength="13"
                    class="form-control"
                    v-bind="integer"
                    placeholder=""
                  ></money>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group bmd-form-group is-filled">
                  <label class="bmd-label-floating">Cota Máx</label>
                  <money
                    v-model="iterator.max_quota"
                    maxlength="13"
                    class="form-control"
                    v-bind="integer"
                    placeholder=""
                  ></money>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group bmd-form-group is-filled">
                  <label class="bmd-label-floating">Comissão</label>
                  <money
                    v-model="iterator.value_quota"
                    maxlength="13"
                    class="form-control"
                    v-bind="money_percent"
                    placeholder=""
                  ></money>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group bmd-form-group is-filled">
                  <label for="quota_type" class="bmd-label-floating"
                    >Tipo</label
                  >
                  <model-list-select
                    class="form-control"
                    :list="types"
                    option-value="id"
                    option-text="name"
                    v-model="iterator.type_quota"
                  >
                  </model-list-select>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group bmd-form-group is-filled">
                  <label for="type" class="bmd-label-floating">Parcela</label>
                  <model-list-select
                    class="form-control"
                    :list="quotas"
                    option-value="id"
                    option-text="id"
                    v-model="iterator.vol_quota"
                  >
                  </model-list-select>
                  <small class="text-info"></small>
                </div>
              </div>
              <div class="col-md-2">
                <b-button block variant="danger" @click="removeQuota(iterator)"
                  >Remover</b-button
                >
              </div>
            </div>
            <hr />
            <h5>
              Valor de Cotas
              <b-button variant="success" @click="addAmount()"
                >Adicionar</b-button
              >
            </h5>
            <div
              class="row"
              v-show="form.campaign.amounts.length > 0"
              v-for="iterator in form.campaign.amounts"
            >
              <div class="col-md-2">
                <div class="form-group bmd-form-group is-filled">
                  <label class="bmd-label-floating">Valor Mín</label>
                  <money
                    v-model="iterator.min_amount"
                    maxlength="13"
                    class="form-control"
                    v-bind="integer"
                    placeholder=""
                  ></money>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group bmd-form-group is-filled">
                  <label class="bmd-label-floating">Valor Máx</label>
                  <money
                    v-model="iterator.max_amount"
                    maxlength="13"
                    class="form-control"
                    v-bind="integer"
                    placeholder=""
                  ></money>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group bmd-form-group is-filled">
                  <label class="bmd-label-floating">Comissão</label>
                  <money
                    v-model="iterator.value_quota"
                    maxlength="13"
                    class="form-control"
                    v-bind="money_percent"
                    placeholder=""
                  ></money>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group bmd-form-group is-filled">
                  <label for="quota_type" class="bmd-label-floating"
                    >Tipo</label
                  >
                  <model-list-select
                    class="form-control"
                    :list="types"
                    option-value="id"
                    option-text="name"
                    v-model="iterator.type_quota"
                  >
                  </model-list-select>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group bmd-form-group is-filled">
                  <label for="type" class="bmd-label-floating">Parcela</label>
                  <model-list-select
                    class="form-control"
                    :list="quotas"
                    option-value="id"
                    option-text="id"
                    v-model="iterator.vol_quota"
                  >
                  </model-list-select>
                  <small class="text-info"></small>
                </div>
              </div>
              <div class="col-md-2">
                <b-button block variant="danger" @click="removeAmount(iterator)"
                  >Remover</b-button
                >
              </div>
            </div>
            <hr />
            <h5>
              Fechamento de Mês
              <b-button variant="success" @click="addCommission()"
                >Adicionar</b-button
              >
            </h5>
            <div
              v-show="form.campaign.closing_months.length > 0"
              v-for="iterator in form.campaign.closing_months"
            >
              <div class="row">
                <div class="col-md-2">
                  <div class="form-group bmd-form-group is-filled">
                    <label class="bmd-label-floating">Cota Inicial</label>
                    <money
                      v-model="iterator.initial_quota"
                      maxlength="13"
                      class="form-control"
                      v-bind="integer"
                      placeholder=""
                    ></money>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group bmd-form-group is-filled">
                    <label class="bmd-label-floating">Cota Final</label>
                    <money
                      v-model="iterator.final_quota"
                      maxlength="13"
                      class="form-control"
                      v-bind="integer"
                      placeholder=""
                    ></money>
                  </div>
                </div>
                <div class="col-md-2">
                  <b-button variant="danger" @click="removeCommission(iterator)"
                    >Remover Cota</b-button
                  >
                </div>
                <div class="col-md-2">
                  <b-button
                    variant="success"
                    @click="addCommissionRange(iterator.commissions)"
                    >Adicionar Comissão</b-button
                  >
                </div>
              </div>
              <div
                class="row"
                v-show="iterator.commissions.length > 0"
                v-for="subIterator in iterator.commissions"
              >
                <div class="col-md-2">
                  <div class="form-group bmd-form-group is-filled">
                    <label class="bmd-label-floating">Parcela</label>
                    <money
                      v-model="subIterator.quote"
                      maxlength="3"
                      class="form-control"
                      v-bind="integer"
                      placeholder=""
                    ></money>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group bmd-form-group is-filled">
                    <label class="bmd-label-floating">Comissão %</label>
                    <money
                      v-model="subIterator.commission"
                      maxlength="9"
                      class="form-control"
                      v-bind="percent"
                      placeholder=""
                    ></money>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group bmd-form-group is-filled">
                    <label class="bmd-label-floating">Cota Mín</label>
                    <money
                      v-model="subIterator.min_quota"
                      maxlength="13"
                      class="form-control"
                      v-bind="integer"
                      placeholder=""
                    ></money>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group bmd-form-group is-filled">
                    <label class="bmd-label-floating">Cota Máx</label>
                    <money
                      v-model="subIterator.max_quota"
                      maxlength="13"
                      class="form-control"
                      v-bind="integer"
                      placeholder=""
                    ></money>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group bmd-form-group is-filled">
                    <label class="bmd-label-floating">Valor de Corte %</label>
                    <money
                      v-model="subIterator.vl_cut"
                      maxlength="9"
                      class="form-control"
                      v-bind="percent"
                      placeholder=""
                    ></money>
                    <small class="text-info"
                      >Valor de Corte da Inadiplência</small
                    >
                  </div>
                </div>
                <div class="col-md-2">
                  <b-button
                    block
                    variant="danger"
                    @click="
                      removeCommissionRange(iterator.commissions, subIterator)
                    "
                    >Remover Comissão</b-button
                  >
                </div>
              </div>
            </div>
          </b-tab>
          <b-tab title="Parcelas Comissionáveis">
            <hr />
            <h5>
              Parcelas
              <b-button variant="success" @click="addInstallments()"
                >Adicionar</b-button
              >
            </h5>
            <div
              class="row"
              v-show="form.installments.length > 0"
              v-for="iterator in form.installments"
            >
              <div class="col-md-2">
                <div class="form-group bmd-form-group is-filled">
                  <label class="bmd-label-floating">Parcela</label>
                  <money
                    v-model="iterator.quote"
                    maxlength="3"
                    class="form-control"
                    v-bind="integer"
                    placeholder=""
                  ></money>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group bmd-form-group is-filled">
                  <label class="bmd-label-floating">Comissão</label>
                  <money
                    v-model="iterator.commission"
                    maxlength="9"
                    class="form-control"
                    v-bind="percent"
                    placeholder=""
                  ></money>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group bmd-form-group is-filled">
                  <label class="bmd-label-floating"
                    >Corte da Inadiplência</label
                  >
                  <money
                    v-model="iterator.cutting_default"
                    maxlength="9"
                    class="form-control"
                    v-bind="percent"
                    placeholder=""
                  ></money>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group bmd-form-group is-filled">
                  <label for="type" class="bmd-label-floating"
                    >Se a parcela estiver paga</label
                  >
                  <model-list-select
                    class="form-control"
                    :list="quotas"
                    option-value="id"
                    option-text="id"
                    v-model="iterator.ref_quota"
                  >
                  </model-list-select>
                  <small class="text-info"></small>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group bmd-form-group is-filled">
                  <label class="bmd-label-floating">Estorno #</label>
                  <money
                    v-model="iterator.commission_reversal"
                    maxlength="9"
                    class="form-control"
                    v-bind="percent"
                    placeholder=""
                  ></money>
                </div>
              </div>
              <div class="col-md-2">
                <b-button
                  block
                  variant="danger"
                  @click="removeInstallment(iterator)"
                  >Remover Comissão</b-button
                >
              </div>
            </div>
          </b-tab>
          <b-tab title="Inadiplência">
            <hr />
            <h5>
              Comissão por inadiplência
              <b-button variant="success" @click="addInadvertenceOnly()"
                >Adicionar</b-button
              >
            </h5>
            <div
              class="row"
              v-show="form.inadvertencies.length > 0"
              v-for="iterator in form.inadvertencies"
            >
              <div class="col-md-2">
                <div class="form-group bmd-form-group is-filled">
                  <label class="bmd-label-floating">Mínimo %</label>
                  <money
                    v-model="iterator.min_percent"
                    maxlength="9"
                    class="form-control"
                    v-bind="percent"
                    placeholder=""
                  ></money>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group bmd-form-group is-filled">
                  <label class="bmd-label-floating">Máximo %</label>
                  <money
                    v-model="iterator.max_percent"
                    maxlength="9"
                    class="form-control"
                    v-bind="percent"
                    placeholder=""
                  ></money>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group bmd-form-group is-filled">
                  <label class="bmd-label-floating">Valor</label>
                  <money
                    v-model="iterator.commission"
                    maxlength="13"
                    class="form-control"
                    v-bind="money"
                    placeholder=""
                  ></money>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group bmd-form-group is-filled">
                  <label for="type" class="bmd-label-floating">Parcela</label>
                  <model-list-select
                    class="form-control"
                    :list="quotas"
                    option-value="id"
                    option-text="id"
                    v-model="iterator.portion"
                  >
                  </model-list-select>
                  <small class="text-info"></small>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group bmd-form-group is-filled">
                  <label for="type" class="bmd-label-floating"
                    >Se a parcela estiver paga</label
                  >
                  <model-list-select
                    class="form-control"
                    :list="quotas"
                    option-value="id"
                    option-text="id"
                    v-model="iterator.portion_pay"
                  >
                  </model-list-select>
                  <small class="text-info"></small>
                </div>
              </div>
              <div class="col-md-2">
                <b-button
                  block
                  variant="danger"
                  @click="removeInadvertenceOnly(iterator)"
                  >Remover</b-button
                >
              </div>
            </div>
          </b-tab>
          <b-tab title="Excedente por parcela">
            <hr />
            <div class="row">
              <div class="col-md-4">
                <div
                  class="form-group bmd-form-group"
                  v-bind:class="{ 'is-filled': true }"
                >
                  <label for="min_value" class="bmd-label-floating"
                    >Valor mínimo vendido sob a 1ª parcela</label
                  >
                  <money
                    maxlength="13"
                    v-model="form.surplus.min_value"
                    class="form-control"
                    v-bind="money"
                    placeholder=""
                  ></money>
                  <label
                    id="min_value-error"
                    class="error"
                    for="min_value"
                    ></label
                  >
                </div>
              </div>
              <div class="col-md-4">
                <div
                  class="form-group bmd-form-group is-filled"
                >
                  <label
                    for="comission_contemplation"
                    class="bmd-label-floating"
                    >Comissão sob a 1ª parcela (%)</label
                  >
                  <money
                    maxlength="9"
                    v-model="form.surplus.commision_on_first_installment"
                    class="form-control"
                    v-bind="percent"
                    placeholder=""
                  ></money>
                  <small class="text-info">Será pago caso o limite mínimo de vendas seja alcançado</small>
                </div>
              </div>
              <div class="col-md-4">
                <div
                  class="form-group bmd-form-group is-filled"
                >
                  <label
                    for="comission_contemplation"
                    class="bmd-label-floating"
                    >Comissão sob a 2ª parcela (%)</label
                  >
                  <money
                    maxlength="9"
                    v-model="form.surplus.commision_on_second_installment"
                    class="form-control"
                    v-bind="percent"
                    placeholder=""
                  ></money>
                  <small class="text-info">Será pago caso a parcela seja de venda que a comissão de 1ª parcela tenha sido paga</small>
                </div>
              </div>
            </div>
          </b-tab>
          <b-tab title="Tipos de Venda">
            <hr />
            <h5>
              Comissão por Tipo de Venda
              <b-button variant="success" @click="addTypeSale()"
                >Adicionar</b-button
              >
            </h5>
            <div class="row"
              v-show="form.type_sales.length > 0"
              v-for="iterator in form.type_sales">
              <div class="col-md-12">
                <div class="row mb-md-3">
                  <div class="col-md-3">
                    <div class="form-group bmd-form-group"
                      v-bind:class="{ 'is-filled': iterator.name != '' }"
                      >
                      <label class="bmd-label-floating">Nome</label>
                      <input
                        v-model="iterator.name"
                        class="form-control" />
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="form-group bmd-form-group"
                      v-bind:class="{ 'is-filled': iterator.code != '' }"
                      >
                      <label class="bmd-label-floating">Código</label>
                      <input
                        v-model="iterator.code"
                        class="form-control" />
                    </div>
                  </div>
                  <div class="col-md-7">
                    <b-button variant="success" @click="addTypeSaleInstallment(iterator)"
                      >Adicionar Parcelas</b-button
                    >
                    <b-button variant="info" @click="addTypeSaleContemplation(iterator)"
                      >Adicionar Contemplação</b-button
                    >
                    <b-button
                      variant="danger"
                      @click="removeTypeSale(iterator)"
                      >Remover Tipo de Venda</b-button
                    >
                  </div>
                </div>
                <div 
                  v-show="iterator.installments.length > 0"
                  >
                  <div class="row"
                    v-for="subIterator in iterator.installments"
                    >
                    <div class="col-md-2">
                      <div class="form-group bmd-form-group is-filled">
                        <label class="bmd-label-floating">Cota Mín</label>
                        <money
                          v-model="subIterator.min_quota"
                          maxlength="13"
                          class="form-control"
                          v-bind="integer"
                          placeholder=""
                        ></money>
                      </div>
                    </div>
                    <div class="col-md-2">
                      <div class="form-group bmd-form-group is-filled">
                        <label class="bmd-label-floating">Cota Máx</label>
                        <money
                          v-model="subIterator.max_quota"
                          maxlength="13"
                          class="form-control"
                          v-bind="integer"
                          placeholder=""
                        ></money>
                      </div>
                    </div>
                    <div class="col-md-2">
                      <div class="form-group bmd-form-group is-filled">
                        <label class="bmd-label-floating">Comissão</label>
                        <money
                          v-model="subIterator.comission"
                          maxlength="13"
                          class="form-control"
                          v-bind="money_percent"
                          placeholder=""
                        ></money>
                      </div>
                    </div>
                    <div class="col-md-2">
                      <div class="form-group bmd-form-group is-filled">
                        <label for="quota_type" class="bmd-label-floating"
                          >Tipo</label
                        >
                        <model-list-select
                          class="form-control"
                          :list="types_to_sales_type"
                          option-value="id"
                          option-text="name"
                          v-model="subIterator.type_commission"
                        >
                        </model-list-select>
                      </div>
                    </div>
                    <div class="col-md-2">
                      <div class="form-group bmd-form-group is-filled">
                        <label for="type" class="bmd-label-floating">Parcela</label>
                        <model-list-select
                          class="form-control"
                          :list="quotas"
                          option-value="id"
                          option-text="id"
                          v-model="subIterator.order"
                        >
                        </model-list-select>
                        <small class="text-info"></small>
                      </div>
                    </div>
                    <div class="col-md-2">
                      <b-button block variant="danger" @click="removeTypeSaleInstallment(subIterator, iterator)"
                        >Remover</b-button
                      >
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <hr class="mb-md-3 mt-md-0" />
                  </div>
                </div>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </b-form>
    <div slot="modal-footer">
      <button @click="onSubmitComission" class="btn btn-rose btn-sm">
        <span class="btn-label">
          <i class="material-icons">done</i>
        </span>
        Salvar
      </button>
      <b-button @click="goBack" size="sm">
        <span class="btn-label">
          <i class="material-icons">{{ "keyboard_arrow_left" }}</i>
        </span>
        {{ "Voltar" }}
      </b-button>
    </div>
  </b-modal>
</template>
<script>
export default {
  computed: {
    administrator: {
      set(_administrator) {},
      get() {
        var self = this;

        if (this.$store.state.administrators.itens.length > 0) {
          var administrator = this.$store.state.administrators.itens.find(
            function (_administrator) {
              if (_administrator.id == self.$route.params.administrator) {
                return _administrator;
              }
            }
          );

          return administrator;
        } else {
          return {
            id: 0,
            name: "",
          };
        }
      },
    },
    form: function() {
      var self = this;
      var commission = self.$store.state.profileCommissions.item;
      console.log(commission);
      return commission;
    },
    groups: {
      set(_groups) {},
      get() {
        return this.$store.state.groups.itens;
      },
    },
    manufacturer_models: {
      set(_manufacturers) {},
      get() {
        return this.$store.state.manufacturers.itens;
      },
    },
    profile: {
      set(_profile) {},
      get() {
        var self = this;

        if (this.$store.state.profiles.itens.length > 0) {
          var profile = this.$store.state.profiles.itens.find(function (
            _profile
          ) {
            if (_profile.id == self.$route.params.id) {
              return _profile;
            }
          });

          return profile;
        } else {
          return {
            id: 0,
            name: "",
          };
        }
      },
    },
  },
  data() {
    return {
      commission: "",
      group: "",
      group_commission: "",
      group_commission_type: "F",
      initial_biling: "",
      initial_quota: "",
      integer: {
        decimal: "",
        thousands: ".",
        prefix: "",
        suffix: "",
        precision: 0,
        masked: false,
      },
      isLoadingCommissions: false,
      final_quota: "",
      finish_biling: "",
      manufacturer_id: "",
      maximum_percentage: "",
      max_quota: "",
      method: "",
      methods: [
        { id: "A", name: "Anular" },
        { id: "D", name: "Diminuir" },
        { id: "M", name: "Multiplicar (pelo total de cotas)" },
        { id: "S", name: "Somar" },
      ],
      minimum_percentage: "",
      min_quota: "",
      modalShow: true,
      model_id: "",
      money_percent: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        suffix: "",
        precision: 5,
        masked: false,
      },
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        suffix: "",
        precision: 2,
        masked: false,
      },
      num_quote: "",
      percent: {
        decimal: ",",
        thousands: "",
        prefix: "",
        suffix: "",
        precision: 5,
        masked: false,
      },
      portion: "",
      quotas: [],
      range: {
        commission: "",
        commissions: [],
        min_quota: "",
        max_quota: "",
        portion: "",
        vl_cut: "",
      },
      ref_quota: "",
      type_portion: "",
      type_portions: [
        { name: "Não Pagas", id: "NP" },
        { name: "Estornadas", id: "E" },
      ],
      type: "",
      type_quota: "",
      types: [
        { name: "Fixo", id: "F" },
        { name: "Percentual", id: "P" },
      ],
      types_to_sales_type: [
        { name: "Fixo", id: "fixed" },
        { name: "Percentual", id: "percentage" },
      ],
      validation: {
        default: {
          comission_default: "",
          max_quotes: "",
          min_quotes: "",
        },
      },
      value: "",
      value_biling: "",
      value_quota: "",
      vl_bonus: "",
      vl_cut: "",
      vol_quota: "",
    };
  },
  mounted() {
    var self = this;

    self.$root.$on("bv::modal::hide", (bvEvent, modalId) => {
      self.goBack();
    });

    for (var i = 1; i <= 120; i++) {
      self.quotas.push({
        id: i,
      });
    }

    self.getDataGroups();
  },
  methods: {
    addBonusQuota() {
      var self = this;
      var quota = {
        num_quote: self.num_quote,
        vl_bonus: self.vl_bonus,
        vl_cut: self.num_quote,
        ref_quota: self.ref_quota,
      };

      self.form.bonus.by_quotas.push(quota);
    },
    addCommission() {
      var self = this;

      var commission = {
        initial_quota: "",
        final_quota: "",
        commissions: [],
      };

      self.form.campaign.closing_months.push(commission);
    },
    addCommissionRange(_commissions) {
      var commission = {
        portion: "",
        commission: "",
        min_quota: "",
        max_quota: "",
        vl_cut: "",
      };

      _commissions.push(commission);
    },
    addInstallments() {
      var self = this;
      var installment = {
        order: "",
        commission: "",
        cutting_default: "",
        with_order_paid: "",
        commission_reversal: "",
      };

      self.form.installments.push(installment);
    },
    addGroupCommission() {
      var self = this;

      var group = {
        group: self.group,
        group_commission_type: self.group_commission_type,
        group_commission: self.group_commission,
      };

      self.form.default.groups.push(group);
    },
    addInadvertence() {
      var self = this;

      var inadvertence = {
        minimum_percentage: self.minimum_percentage,
        maximum_percentage: self.maximum_percentage,
        value: self.value,
        portion: self.portion,
        type: self.type,
        method: self.method,
        type_portion: self.type_portion,
      };

      self.form.default.inadvertencies.push(inadvertence);
    },
    addInadvertenceOnly() {
      var self = this;

      var inadvertence = {
        min_percent: 0,
        max_percent: 0,
        commission: 0,
        portion: 0,
        portion_pay: 0,
      };

      self.form.inadvertencies.push(inadvertence);
    },
    addQuota() {
      var self = this;

      var quota = {
        min_quota: self.min_quota,
        max_quota: self.max_quota,
        value_quota: self.value_quota,
        type_quota: self.type_quota,
        vol_quota: self.vol_quota,
      };

      self.form.campaign.quotas.push(quota);
    },
    addAmount() {
      var self = this;

      var amount = {
        min_amount: "",
        max_amount: "",
        value_quota: "",
        type_quota: "",
        vol_quota: "",
      };

      self.form.campaign.amounts.push(amount);
    },
    addRange() {
      var self = this;

      var range = {
        initial_billing: self.initial_billing,
        final_billing: self.finish_billing,
        commission: self.commission,
      };

      self.form.billing.ranges.push(range);
    },
    addVehicleCommission() {
      var self = this;
      var commission = {
        commission: "",
        model: {
          id: "",
          manufacturer: {
            id: "",
          },
        },
        model_id: "",
      };
      self.form.default.commissioned_vehicles.push(commission);
    },
    addTypeSale() {
      var self = this;
      var typeSale = {
        name: "",
        code: "",
        installments: []
      };
      self.form.type_sales.push(typeSale);
    },
    addTypeSaleContemplation(_typeSale) {
      var contemplation = {
        order: 800,
        comission: 0
      };
      _typeSale.installments.push(contemplation);
    },
    addTypeSaleInstallment(_typeSale) {
      var installment = {
        order: 0,
        comission: 0
      };
      _typeSale.installments.push(installment);      
    },
    goBack() {
      var self = this;
      self.$router.push({
        name: "profiles.administrators.index",
        params: { id: self.$route.params.id },
      });
    },
    remBonusQuota(_quota) {
      var self = this;
      self.$dialog
        .confirm("Deseja realmente remover a comissão de bonus por parcela?")
        .then(function () {
          var quotaIndex = self.form.bonus.by_quotas.indexOf(_quota);
          self.form.bonus.by_quotas.splice(quotaIndex, 1);
        });
    },
    removeCommission(_commission) {
      var self = this;
      self.$dialog
        .confirm("Deseja realmente remover a comissão para fechamento de mês?")
        .then(function () {
          var commissionIndex =
            self.form.campaign.closing_months.indexOf(_commission);
          self.form.campaign.closing_months.splice(commissionIndex, 1);
        });
    },
    removeCommissionRange(_commissions, _commission) {
      var self = this;
      self.$dialog
        .confirm("Deseja realmente remover a comissão para fechamento de mês?")
        .then(function () {
          var commissionIndex = _commissions.indexOf(_commission);
          _commissions.splice(commissionIndex, 1);
        });
    },
    removeGroupCommission(_groupCommision) {
      var self = this;
      self.$dialog
        .confirm("Deseja realmente remover a comissão de grupo?")
        .then(function () {
          var groupCommisionIndex =
            self.form.default.groups.indexOf(_groupCommision);
          self.form.default.groups.splice(groupCommisionIndex, 1);
        });
    },
    removeInadvertence(_inadvertence) {
      var self = this;
      self.$dialog
        .confirm("Deseja realmente remover a comissão de inadiplência?")
        .then(function () {
          var inadvertenceIndex =
            self.form.default.inadvertencies.indexOf(_inadvertence);
          self.form.default.inadvertencies.splice(inadvertenceIndex, 1);
        });
    },
    removeInadvertenceOnly(_inadvertence) {
      var self = this;
      self.$dialog
        .confirm("Deseja realmente remover a comissão de inadiplência?")
        .then(function () {
          var inadvertenceIndex =
            self.form.inadvertencies.indexOf(_inadvertence);
          self.form.inadvertencies.splice(inadvertenceIndex, 1);
        });
    },
    removeInstallment(_installment) {
      var self = this;
      self.$dialog
        .confirm("Deseja realmente remover a parcela comissionável?")
        .then(function () {
          var installmentIndex = self.form.installments.indexOf(_installment);
          self.form.installments.splice(installmentIndex, 1);
        });
    },
    removeQuota(_quota) {
      var self = this;
      self.$dialog
        .confirm("Deseja realmente remover a comissão de volume de cota?")
        .then(function () {
          var quotaIndex = self.form.campaign.quotas.indexOf(_quota);
          self.form.campaign.quotas.splice(quotaIndex, 1);
        });
    },
    removeAmount(_amount) {
      var self = this;
      self.$dialog
        .confirm("Deseja realmente remover a comissão de valor de cotas?")
        .then(function () {
          var amountIndex = self.form.campaign.quotas.indexOf(_amount);
          self.form.campaign.amounts.splice(amountIndex, 1);
        });
    },
    removeRange(_range) {
      var self = this;
      self.$dialog
        .confirm("Deseja realmente remover a comissão de faixa?")
        .then(function () {
          var rangeIndex = self.form.billing.ranges.indexOf(_range);
          self.form.billing.ranges.splice(rangeIndex, 1);
        });
    },
    removeVehicleCommission(_vehicleCommission) {
      var self = this;
      self.$dialog
        .confirm(
          "Deseja realmente remover a comissão para o veículo " +
            _vehicleCommission.model.manufacturer.name +
            "/" +
            _vehicleCommission.model.name +
            "?"
        )
        .then(function () {
          var vehicleCommissionIndex =
            self.form.default.commissioned_vehicles.indexOf(_vehicleCommission);
          self.form.default.commissioned_vehicles.splice(
            vehicleCommissionIndex,
            1
          );
        });
    },
    removeTypeSale(_typeSale) {
      var self = this;
      self.$dialog
        .confirm(
          "Deseja realmente remover o tipo de venda " +
          _typeSale.name +
            "?"
        )
        .then(function () {
          var typeSaleIndex = self.form.type_sales.indexOf(_typeSale);
          self.form.type_sales.splice(typeSaleIndex, 1);
        });
    },
    removeTypeSaleInstallment(_installment, _typeSale) {
      var self = this;
      self.$dialog
        .confirm(
          "Deseja realmente remover a parcela de comissão para o tipo de venda " +
          _typeSale.name +
            "?"
        )
        .then(function () {
          var installmentIndex = _typeSale.installments.indexOf(_installment);
          _typeSale.installments.splice(installmentIndex, 1);
        });
    },
    async getData() {
      var self = this;

      self.$root.$emit("onLoading");

      const response = self.$store.dispatch("profileCommissions/get", {
        profile_id: parseInt(self.$route.params.id),
        administrator_id: parseInt(self.$route.params.administrator),
      });

      response.then(function () {
        self.$root.$emit("onLoading");
      });

      response.catch(function () {
        self.$root.$emit("onLoading");
      });
    },
    async getDataGroups() {
      var self = this;

      self.$root.$emit("onLoading");

      const response = self.$store.dispatch(
        "groups/allByAdministratorId",
        parseInt(self.$route.params.administrator)
      );

      response.then(function () {
        self.getDataManufacturers();
        self.$root.$emit("onLoading");
      });

      response.catch(function () {
        self.getDataManufacturers();
        self.$root.$emit("onLoading");
      });
    },
    async getDataManufacturers() {
      var self = this;

      self.$root.$emit("onLoading");
      const response = self.$store.dispatch("manufacturers/all_with_models");

      response.then(function () {
        self.getData();
        self.$root.$emit("onLoading");
      });

      response.catch(function () {
        self.getData();
        self.$root.$emit("onLoading");
      });
    },
    onSubmitComission(_ev) {
      var self = this;
      var valid = true;

      _ev.preventDefault();

      self.$root.$emit("onLoading");

      const response = self.$store.dispatch("profileCommissions/set", {
        profile_id: parseInt(self.$route.params.id),
        administrator_id: parseInt(self.$route.params.administrator),
        form: self.form,
      });

      response.then(function () {
        self.$root.$emit("onLoading");
        self.$notify.success("Comissões do perfil salvas com sucesso!");
        self.goBack();
      });

      response.catch(function (err) {
        self.$root.$emit("onLoading");
      });
    },
  },
};
</script>